import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Benachrichtigung } from './../classes/benachrichtigung';
import { HttpParams } from '@angular/common/http';
import { Ticket, TicketFarben, TicketKommentar } from './../../classes/ticket';
import { Subscription } from 'rxjs';
import { MessageService } from './../../services/message-service/message.service';
import { API_BASE_URL_SERVICE } from './../../kiene-core.config';
import { KieneBackendApiService } from './../../services/backend-api/kiene-backend-api.service';
import { FormControl } from '@angular/forms';
import { LocalStorageService } from './../../services/local-storage/local-storage.service';
import { ConfirmDialogInput } from './../../components/dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from './../../components/dialogs/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'kiene-benachrichtigung-dialog',
    templateUrl: './benachrichtigung-dialog.component.html',
    styleUrls: ['./benachrichtigung-dialog.component.scss'],
})
export class BenachrichtigungDialogComponent implements OnInit {
    ticket: Ticket = new Ticket();
    loadTicketSub = new Subscription();
    kommentarCtrl = new FormControl();
    isLoadingOrSaving = false;
    neuerKommentarPublicCtrl = new FormControl(true);
    isAdmin = false;
    currentUserId: number;

    constructor(
        public dialogRef: MatDialogRef<BenachrichtigungDialogComponent>,
        private messageService: MessageService,
        @Inject(MAT_DIALOG_DATA) public nachricht: Benachrichtigung,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneBackendApiService,
        private localStorageService: LocalStorageService,
        private dialog: MatDialog,
    ) {}

    ngOnInit(): void {
        this.isAdmin = this.localStorageService.currentUserIsAdmin();
        this.currentUserId = this.localStorageService.getCurrentUser()?.benutzer_id;
        if (this.nachricht.ticket_id) {
            this.loadTicket();
        }
    }

    public getColor(status_id: number): string {
        return TicketFarben.getColor(status_id);
    }

    onNoClick() {
        this.dialogRef.close();
    }

    public addComment(): void {
        const kommentar = new TicketKommentar();
        kommentar.kommentar = this.kommentarCtrl.value;
        kommentar.ticket_id = this.ticket.ticket_id;
        kommentar.erstellt_von = this.currentUserId;
        kommentar.oeffentlich = this.neuerKommentarPublicCtrl.value ? 1 : 0;
        kommentar.erstellt = new Date().toISOString();
        kommentar.ersteller =
            this.localStorageService.getCurrentUser()?.vorname +
            ' ' +
            this.localStorageService.getCurrentUser()?.nachname;
        this.postComment(kommentar);
    }

    public deletableComment(kommentar: TicketKommentar): boolean {
        if (this.isAdmin) return true;
        if (!this.localStorageService.hasPermission(10038)) return false;
        return kommentar.erstellt_von == this.currentUserId;
    }

    public deleteComment(kommentar: TicketKommentar): void {
        const input = new ConfirmDialogInput();
        input.headline = 'Kommentar löschen';
        input.text = 'Soll der Kommentar wirklich gelöscht werden?';
        input.okButton = 'Löschen';
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: result => {
                    if (result.confirmed) {
                        this.isLoadingOrSaving = true;
                        this.api.deleteEntity(this.apiBaseUrl + 'ticket_kommentar/delete.php', kommentar).subscribe({
                            next: () => {
                                this.ticket.kommentare = this.ticket.kommentare.filter(
                                    k => k.tk_id !== kommentar.tk_id,
                                );
                                this.isLoadingOrSaving = false;
                            },
                            error: err => {
                                this.isLoadingOrSaving = false;
                                this.messageService.errorMessage('Kommentar konnte nicht gelöscht werden!', err);
                            },
                        });
                    }
                },
            });
    }

    private postComment(kommentar: TicketKommentar): void {
        this.isLoadingOrSaving = true;
        this.api.post(this.apiBaseUrl + 'ticket_kommentar/create.php', kommentar).subscribe({
            next: () => {
                if (!this.ticket.kommentare) {
                    this.ticket.kommentare = [];
                }
                this.loadTicket();
                this.isLoadingOrSaving = false;
                this.kommentarCtrl.reset();
            },
            error: err => {
                this.isLoadingOrSaving = false;
                this.messageService.errorMessage('Kommentar konnte nicht gespeichert werden!', err);
            },
        });
    }

    private loadTicket(): void {
        this.isLoadingOrSaving = true;
        this.loadTicketSub?.unsubscribe();
        const params = new HttpParams().set('ticket_id', this.nachricht.ticket_id.toString());
        this.loadTicketSub = this.api.get(this.apiBaseUrl + 'ticket/read_one.php', params).subscribe({
            next: res => {
                this.ticket = res;
                this.isLoadingOrSaving = false;
                this.loadTicketSub.unsubscribe();
            },
            error: err => {
                this.isLoadingOrSaving = false;
                this.loadTicketSub.unsubscribe();
                this.messageService.errorMessage('Fehler beim Laden des Tickets', err);
            },
        });
    }
}
